import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

const DocsMenu = ({ dropdown, items }) => {
  if (dropdown) {
    return (
      <select onChange={(e) => { window.location = e.target.value; }}>
        {items.map(item => (
          <option className={item.hidden && 'hidden'} value={item.url}>
            {item.section ? item.text : `- ${item.text}`}
          </option>
        ))}
      </select>
    );
  }
  return (
    <ul>
      {items.map((item) => {
        const classes = cx(item.section && 'section', item.hidden && 'hidden');
        return (
          <li className={classes}>
            <a className={item.hidden && 'hidden'} href={item.url}>
              {item.text}
            </a>
          </li>
        );
      })}
    </ul>
  );
};

DocsMenu.propTypes = {
  dropdown: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      hidden: PropTypes.bool,
      section: PropTypes.bool,
    }),
  ).isRequired,
};

DocsMenu.defaultProps = {
  dropdown: false,
};

export default DocsMenu;
